export default "__VITE_ASSET__Bx9tqh3g__"